//
// Manages floating ads.
function AdsNinjaFloatingDelegate(maxNumberOfRefloatsBanner, maxNumberOfRefloatsOutstream, logger, eventHelper, callbacks){

    this.__logger                       = logger;
    this.__waypoints                    = {};
    this.__refloatCountByAd             = {};
    this.__maxNumberOfRefloatsBanner    = maxNumberOfRefloatsBanner || 0;
    this.__maxNumberOfRefloatsOutstream = maxNumberOfRefloatsOutstream || 2;
    this.__eventHelper                  = eventHelper;
    this.callbacks                      = callbacks;
    this.__highImpactAdShowing          = false;
    this.__highImpactAdTier             = null;
}

//
// Return true an element is floating.
AdsNinjaFloatingDelegate.prototype.isAdFloating = function(ad){

    if(!ad){

        this.__logger.warn('Unable to determine if ad is floating.');
        return false;
    }

    var adZoneElement = ad.getAdZoneElement();

    if(!adZoneElement){

        this.__logger.warn('Unable to determine floating for ad: element does not exist!', {
            adElementId: ad.getAdElementId(),
            element: 'adZoneElement',
        });
        return false;
    }

    return ('true' === adZoneElement.getAttribute('data-is-floating'));
};

//
// Add waypoint.
AdsNinjaFloatingDelegate.prototype.addWaypoint = function(key, waypoint){

    if(!key || !waypoint){
    
        this.__logger.warn('Unable to add waypoint. Missing parameters.', {
            key: key,
            waypoint: waypoint,
        })
        return;
    }

    if(!this.__waypoints.hasOwnProperty(key)){

        this.__waypoints[key] = [];
    }

    this.__waypoints[key].push(waypoint);
}

//
// Checks if ad has waypoints.
AdsNinjaFloatingDelegate.prototype.hasWaypoints = function(key){
    
    return (this.__waypoints.hasOwnProperty(key) && this.__waypoints[key].length > 0);
}

//
// Delete waypoints if exists.
AdsNinjaFloatingDelegate.prototype.deleteWaypoints = function(key){

    if(!this.__waypoints.hasOwnProperty(key)){

        return;
    }

    for(var x in this.__waypoints[key]){

        var waypoint = this.__waypoints[key][x];

        if(waypoint instanceof IntersectionObserver){

            waypoint.disconnect();
        }
        else{

            waypoint.destroy();
        }
    }

    delete this.__waypoints[key];
},

//
// Disable waypoints if exists.
AdsNinjaFloatingDelegate.prototype.disableWaypoints = function(key){

    if(!this.__waypoints.hasOwnProperty(key)){

        return;
    }

    for(var x in this.__waypoints[key]){

        var waypoint = this.__waypoints[key][x];

        if(waypoint instanceof IntersectionObserver){

            waypoint.disconnect(); // TODO: Re-float won't work.
        }
        else{

            waypoint.disable();
        }
    }
},

//
// Enable waypoints if exists.
AdsNinjaFloatingDelegate.prototype.enableWaypoints = function(key){

    if(!this.__waypoints.hasOwnProperty(key)){

        return;
    }

    for(var x in this.__waypoints[key]){

        this.__waypoints[key][x].enable();
    }
},

//
// Determine if an ad can refloat.
AdsNinjaFloatingDelegate.prototype.canRefloat = function(key, type){

    if(!key || !type){

        return false;
    }

    if(!this.__refloatCountByAd.hasOwnProperty(key)){

        this.__refloatCountByAd[key] = 0;
    }

    var maxNumberOfRefloats = 0;
    
    switch(type){

        case 'banner':

            maxNumberOfRefloats = this.__maxNumberOfRefloatsBanner;

            break;

        case 'outstream':

            maxNumberOfRefloats = this.__maxNumberOfRefloatsOutstream;

            break;
    } 
    
    return (this.__refloatCountByAd[key] < maxNumberOfRefloats);
};

//
// Increment counter.
AdsNinjaFloatingDelegate.prototype.incrementRefloatCount = function(key){

    if(!this.__refloatCountByAd.hasOwnProperty(key)){

        this.__refloatCountByAd[key] = 0;
    }

    this.__refloatCountByAd[key]++;
};

//
// Hide close button.
AdsNinjaFloatingDelegate.prototype.hideCloseButton = function(ad){

    return this.__toggleCloseButton(ad, 'hide');
};

//
// Show close button.
AdsNinjaFloatingDelegate.prototype.showCloseButton = function(ad, options){

    return this.__toggleCloseButton(ad, 'show', options);
};

//
// Toggles the close button to the desired state.
AdsNinjaFloatingDelegate.prototype.__toggleCloseButton = function(ad, context, options){

    if(!ad){

        this.__logger.warn(`Unable to find ad unit with ad element id: ${adElementId}.`);
        return false;
    }

    // Check if ad button is needed.
    var floatingOptions = ad.getFloatingOptions();

    if(!floatingOptions || typeof floatingOptions !== 'object' || Object.keys(floatingOptions).length === 0 || !floatingOptions['useCloseButton']){

        this.__logger.debug('Close button not needed or unable to find floating options.');
        return false;
    }

    var adZoneInlineElement = ad.getAdZoneInlineElement();

    if(!adZoneInlineElement){

        this.__logger.warn(`Unable to find element.`, {
            adElementId: adElementId,
            element: 'adZoneInlineElement',
        });
        return false;
    }

    // Re-enable close button if needed.
    var adCloseButtonElement = adZoneInlineElement.getElementsByClassName('close-ad-zone')[0];

    if(adCloseButtonElement && 'show' === context){

        adCloseButtonElement.classList.add('an-close-btn-visible');
        return true;
    }
    else if(adCloseButtonElement && 'hide' === context){

        adCloseButtonElement.classList.remove('an-close-btn-visible');
        return true;
    }
    else if(!adCloseButtonElement && 'hide' !== context){

        // Add close button.
        this.__addCloseButton(ad, options);
        return true;
    }
};

//
// Add close button.
AdsNinjaFloatingDelegate.prototype.__addCloseButton = function(ad, options){ 

    var adElementId            = ad.getAdElementId();
    var adZoneContainerElement = ad.getAdZoneContainerElement();
    var adZoneInlineElement    = ad.getAdZoneInlineElement();

    if(!adZoneContainerElement || !adZoneInlineElement){

        this.__logger.warn('Unable to add close button: one or more elements does not exist!', {
            adElementId: adElementId,
            elements: [
                'adZoneContainerElement',
                'adZoneInlineElement',
            ],
        });
        return;
    }

    var closeButtonId   = `close-ad-zone-${adElementId}`;
    var button          = document.createElement('button');
    button.className    = 'an-close-btn close-ad-zone an-close-btn-visible';
    button.id           = closeButtonId;
    button.innerHTML    = options.text;
    button.style        = options.style;
    button.style.zIndex = options.zIndex
    var self            = this;

    if(adZoneContainerElement.classList.contains('ad-loaded') || options.isUsingFakeAds){

        button.classList.add('an-close-btn-visible');
    }

    button.addEventListener('click', function(event){ // TODO: Delete with button.

        self.callbacks.handleAdCloseButtonClick(event, ad);
    }, false);

    adZoneInlineElement.prepend(button);
};

//
// Set high impact ad showing.
AdsNinjaFloatingDelegate.prototype.setHighImpactAdShowing = function(value, tier = 1){

    this.__highImpactAdShowing = value;
    this.__highImpactAdTier    = (value) ? tier : null;

    if(!this.__highImpactAdShowing){
        document.body.classList.add('an-not-high-impact-showing');
        document.body.classList.remove('an-high-impact-showing');
        document.body.classList.remove(`an-high-impact-tier-1`);
        document.body.classList.remove(`an-high-impact-tier-2`);
    }
    else{
        document.body.classList.remove('an-not-high-impact-showing');
        document.body.classList.add('an-high-impact-showing');
        document.body.classList.add(`an-high-impact-tier-${this.__highImpactAdTier}`);
    }
}

window.AdsNinjaFloatingDelegate = AdsNinjaFloatingDelegate;